<script>
import { loadingComputed } from '@state/helpers/loading'
export default {
  computed: {
    ...loadingComputed,
    pageName() {
      return this.$route.name
    },
    loading() {
      return this.getLoading || false
    },
  },
}
</script>

<template>
  <div id="app">
    <BaseSideBar />
    <CWrapper>
      <BaseHeader />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <h4 class="font-weight-bold mb-3">{{ $t(`pages.${pageName}`) }}</h4>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <BaseFooter />
    </CWrapper>
    <BaseModalGlobalConfirm />
    <div
      v-if="loading"
      style="position: fixed; top: 0;bottom: 0; z-index: 9999; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"
    >
      <div
        class="c-app justify-content-center align-items-center"
        style="background-color: unset;"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media (min-width: 992px) and (min-width: 992px) {
  html:not([dir='rtl'])
    .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed
    ~ .c-wrapper,
  html:not([dir='rtl'])
    .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed
    ~ .c-wrapper {
    margin-left: 240px;
  }
}
</style>
